<template>
    <div class="modal fade asign_client_modal" id="assignClientModal" tabindex="-1" role="dialog"
         aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="dismiss-modal-btn" @click="dismissModal()">
                <i class="fad fa-times-circle"></i>
            </div>
            <div class="modal-content" v-if="item">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="choose-client-tab" data-toggle="tab" href="#choose_client_tab"
                           role="tab" aria-controls="choose_client_tab" aria-selected="true">
                            <i class="fad fa-user-check"></i>
                            <span>
                                Alege client
                            </span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="add-client-tab" data-toggle="tab" href="#add_client_panel" role="tab"
                           aria-controls="add_client_panel" aria-selected="false">
                            <i class="fad fa-user-plus"></i>
                            <span>
                        Adauga client
                    </span>
                        </a>
                    </li>
                </ul>
                <div class="modal-body">
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="choose_client_tab" role="tabpanel"
                             aria-labelledby="choose_client_tab">
                            <div class="row justify-content-center chose-client-row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mgb-3 mt-3">
                                    <div class="v-select-container">
                                        <div class="v-select-icon">
                                            <i class="fad fa-user-check"></i>
                                        </div>
                                        <vSelect :options="clients" @input="showPriceInput()" v-model="selected"
                                                 :get-option-label="clientName"></vSelect>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-8 col-sm-12 col-12 mgb-3"
                                     :class="[selected ? 'visible-col' : 'hidden-col']">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input id="exitsting_client_model_price" placeholder="* Pret final"
                                                   name="exitsting_client_model_price" v-model="clientModelPrice"
                                                   type="number">
                                            <div class="input-icon">
                                                <i class="fad fa-tag"></i>
                                            </div>
                                            <label class="custom-label" for="exitsting_client_model_price"> *Pret
                                                final </label>
                                        </div>
                                        <p class="custom-input-error"></p>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-8 col-sm-12 col-12 mgb-3"
                                     :class="[selected ? 'visible-col' : 'hidden-col']">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input id="existing_client_payed_advance" placeholder="* Avans"
                                                   name="existing_client_payed_advance" v-model="clientPayedAdvance"
                                                   type="text">
                                            <div class="input-icon">
                                                <i class="fad fa-hand-holding-usd"></i>
                                            </div>
                                            <label class="custom-label" for="existing_client_payed_advance">
                                                *Avans </label>
                                        </div>
                                        <p class="custom-input-error"></p>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-8 col-sm-12 col-12 mgb-3"
                                     :class="[selected ? 'visible-col' : 'hidden-col']">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input id="existing_client_remaining_payment" placeholder="* Rest de plata"
                                                   name="existing_client_remaining_payment"
                                                   :value="clientModelPrice - clientPayedAdvance" type="text">
                                            <div class="input-icon">
                                                <i class="fad fa-usd-circle"></i>
                                            </div>
                                            <label class="custom-label" for="existing_client_remaining_payment"> *Rest
                                                de
                                                plata </label>
                                        </div>
                                        <p class="custom-input-error"></p>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div class="center-content mt-3">
                                        <button type="button" class="general-btn positive-btn" @click="saveClient()">
                                            <i class="fad fa-user-check"></i>
                                            <span> Salveaza client </span>
                                        </button>
                                        <button type="button" name="button" class="general-btn negative-btn"
                                                data-dismiss="modal"><i class="fad fa-times-circle"></i>
                                            <span> Anuleaza </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="add_client_panel" role="tabpanel"
                             aria-labelledby="add_client_panel-tab">
                            <form id="add_client_form">
                                <div class="row">
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                                <input id="client_last_name" placeholder="* Nume" name="last_name"
                                                       value=""
                                                       type="text">
                                                <div class="input-icon">
                                                    <i class="fad fa-signature"></i>
                                                </div>
                                                <label class="custom-label" for="client_last_name"> *Nume </label>
                                            </div>
                                            <p class="custom-input-error" id="last_name_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                                <input id="client_first_name" placeholder="* Prenume" name="first_name"
                                                       value="" type="text">
                                                <div class="input-icon">
                                                    <i class="fad fa-signature"></i>
                                                </div>
                                                <label class="custom-label" for="client_first_name"> *Prenume </label>
                                            </div>
                                            <p class="custom-input-error" id="first_name_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                                <input id="client_phone" placeholder="Telefon" name="phone" value=""
                                                       type="text">
                                                <div class="input-icon">
                                                    <i class="fad fa-phone-rotary"></i>
                                                </div>
                                                <label class="custom-label" for="client_phone"> Telefon </label>
                                            </div>
                                            <p class="custom-input-error" id="phone_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                                <input id="client_email" placeholder="* Email" name="email" value=""
                                                       type="text">
                                                <div class="input-icon">
                                                    <i class="fad fa-at"></i>
                                                </div>
                                                <label class="custom-label" for="client_email"> *Email </label>
                                            </div>
                                            <p class="custom-input-error" id="email_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                        <textarea name="details" id="client_details"
                                                  placeholder="Detalii client"></textarea>
                                                <div class="input-icon">
                                                    <i class="fad fa-info-circle"></i>
                                                </div>
                                                <label class="custom-label" for="client_details"> Detalii client </label>
                                            </div>
                                            <p class="custom-input-error" id="details_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                                <input id="client_model_price" placeholder="* Pret final"
                                                       name="client_model_price"
                                                       v-model="clientModelPrice" type="text">
                                                <div class="input-icon">
                                                    <i class="fad fa-tag"></i>
                                                </div>
                                                <label class="custom-label custom-label-active"
                                                       for="client_model_price"> *Pret
                                                    final </label>
                                            </div>
                                            <p class="custom-input-error" id="model_price_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                                <input id="client_payed_advance" placeholder="* Avans"
                                                       name="client_payed_advance"
                                                       v-model="clientPayedAdvance" type="text">
                                                <div class="input-icon">
                                                    <i class="fad fa-hand-holding-usd"></i>
                                                </div>
                                                <label class="custom-label custom-label-active" for="client_payed_advance">
                                                    *Avans </label>
                                            </div>
                                            <p class="custom-input-error" id="payed_advance_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mgb-3">
                                        <div class="input-container">
                                            <div class="input-group mg-b">
                                                <input id="client_remaining_payment" placeholder="* Rest de plata"
                                                       name="client_remaining_payment"
                                                       :value="clientModelPrice - clientPayedAdvance" type="text">
                                                <div class="input-icon">
                                                    <i class="fad fa-usd-circle"></i>
                                                </div>
                                                <label class="custom-label custom-label-active" for="client_remaining_payment">
                                                    *Rest de plata </label>
                                            </div>
                                            <p class="custom-input-error" id="remaining_payment_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                        <div class="center-content mt-3">
                                            <button type="button" class="general-btn positive-btn" @click="save()">
                                                <i class="fad fa-user-plus"></i>
                                                <span> Salveaza client </span>
                                            </button>
                                            <button type="button" name="button" class="general-btn negative-btn"
                                                    data-dismiss="modal"><i class="fad fa-times-circle"></i>
                                                <span> Anuleaza </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    name: "AssignClient",
    components: {
      vSelect,
    },
    data() {
      return {
        visibleInput: false,
        item: null,
        selected: '',
        clients: [],
        clientModelPrice: 0,
        clientPayedAdvance: 0,
        urlPrams: null
      }
    },
    async mounted() {
      let vm = this
      this.urlPrams = window.getAllUrlParams();
      $('#assignClientModal').on('hidden.bs.modal', function () {
        vm.item = null
        vm.clientModelPrice = 0
        vm.clientPayedAdvance = 0
        vm.selected = ''
      });
      this.$eventBus.$on('OPEN_ASSIGN_CLIENT_MODAL',async function (payLoad) {
        vm.triggerLoader(true)
        vm.item = payLoad.item;
        await vm.getClients()
        vm.clientModelPrice = vm.item.final_price ? vm.item.final_price : vm.item.price
        vm.clientPayedAdvance = vm.item.advance_amount ? vm.item.advance_amount : 0
        vm.selected = vm.clients.find(client => client.id == vm.item.client_id)
        if (!vm.selected) {
          if (vm.urlPrams && vm.urlPrams.client && vm.urlPrams.client > 0) {
            vm.selected = vm.clients.find(client => client.id == vm.urlPrams.client)
          }
        }
        vm.triggerLoader(false)
        $('#assignClientModal').modal('show')
      });
    },
    methods: {
      dismissModal() {
        $('#assignClientModal').modal('hide')
      },
      showPriceInput() {
        if (this.selected !== null) {
          this.visibleInput = true
          // console.log('hasvalue')
          // console.log(this.selected);
        } else {
          this.visibleInput = false
          // console.log('doesnthavevalue')
          // console.log(this.selected);
        }
      },
      async getClients() {
        let vm = this
        await window.axios.get(`/developer/clients/data-list/${this.item.project_id}`)
          .then(function (resp) {
            vm.clients = resp.data.data
          })
          .catch(function (err) {
            window.showError(err)
          });
      },
      save() {
        this.triggerLoader(true)
        let vm = this
        window.resetErrors()
        let myForm = document.getElementById('add_client_form');
        let formData = new FormData(myForm);
        formData.append('item_id', this.item.id);
        window.axios.post(`/developer/items/clients`, formData)
          .then(function () {
            $('#assignClientModal').modal('hide')
            vm.$eventBus.$emit('CLIENT_ASSIGNED');
            vm.triggerLoader(false)
            window.Swal.fire({
              position: 'top-end',
              icon: 'success',
              html: 'Clientul a fost asignat cu succes.',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            })
          })
          .catch(function (err) {
            vm.triggerLoader(false)
            window.showError(err,'add_client_form')
          });
      },
      saveClient() {
        this.triggerLoader(true)
        let vm = this
        window.resetErrors()
        window.axios.post(`/developer/items/assign-client`, {
          item_id: vm.item.id,
          client_id: vm.selected ? vm.selected.id : null,
          advance_amount: vm.clientPayedAdvance,
          final_price: vm.clientModelPrice
        })
          .then(function () {
            $('#assignClientModal').modal('hide')
            vm.$eventBus.$emit('CLIENT_ASSIGNED');
            vm.triggerLoader(false)
            window.Swal.fire({
              position: 'top-end',
              icon: 'success',
              html: 'Clientul a fost asignat cu succes.',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(function () {
              if (vm.urlPrams && vm.urlPrams.client) {
                window.location.href = '/developer/clients'
              }
            })
          })
          .catch(function (err) {
            vm.triggerLoader(false)
            window.showError(err)
          });
      }
    }
  }
</script>
